module.exports = __webpack_public_path__ + "img/ch74.c3ea4a79.jpg";